import {
  inBrowser,
  isBrowserOnline,
  isValidBrowser,
  isValidBrowserOnline,
  userAgentIsRobot
} from "./chunk-JKSAJ6AV.mjs";
import "./chunk-7ELT755Q.mjs";
export {
  inBrowser,
  isBrowserOnline,
  isValidBrowser,
  isValidBrowserOnline,
  userAgentIsRobot
};
//# sourceMappingURL=browser.mjs.map